module.exports = __webpack_public_path__ + "img/cooperate_10.31130994.png";